import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  border-radius: 0.17648rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  width: 45rem;
  font-family: Sora;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const Content = styled.div`
  padding: 1.75rem 1.82375rem 1.75rem 1.82375rem;
  input {
    width: 22.354375rem;
    border-radius: 0.35296625rem;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  span {
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 1.3125rem;
    margin-left: 0.52rem;
  }
`;

export const Button = styled.button`
  font-family: Sora;
  text-align: center;
  width: 6.95625rem;
  height: 2.461875rem;
  padding: 0;
  line-height: 0.875rem;
  font-size: 0.70625rem;
  font-weight: bold;
  color: #fff;
  border-radius: 0.353rem;
  border: none;
  align-self: flex-end;
  background-color: #585e66;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover {
    filter: brightness(0.9);
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Sora";

  span {
    font-weight: 600;
    font-size: 0.7062rem;
    line-height: 0.875rem;
    margin-bottom: 0.3608rem;
    color: #585e66;
  }

  textarea {
    min-height: 10rem;
    border: 2px solid #d4d6da;
    border-radius: 8.47434px;
    outline: none;
    resize: none;
    padding: 0.5rem 0.75rem;
  }
`;
export const Counter = styled.span`
  margin-top: 0.5rem;
  margin-right: 0.2rem;
  font-size: 0.8rem;
  line-height: 0.95rem;
  text-align: right;

  color: #585e66;
`;
